import { Component, OnInit } from '@angular/core';
import { ProspectService } from 'services/prospect.service';
import { Router } from '@angular/router';
import { ProspectTourSummary } from 'app/models/prospect-tour-summary';
import { createCalendar } from 'add-to-calendar-buttons';
import { ErrorService } from 'services/error.service';
import {MatIconModule} from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-add-self-tour-to-calendar',
  templateUrl: './add-self-tour-to-calendar.component.html',
  styleUrls: ['./add-self-tour-to-calendar.component.css']
})
export class AddSelfTourToCalendarComponent implements OnInit {

  model: ProspectTourSummary = new ProspectTourSummary();
  selfTourKey: String = null;
  errorMessage: String = null;
  tourDateSummary: String = null;

  constructor(private prospectService: ProspectService, public router: Router, private errorService: ErrorService) {

    let selfTourKey = localStorage.getItem('SelfTourKey');

    if (selfTourKey !== null && selfTourKey !== undefined)
    {
      this.selfTourKey = selfTourKey;
    }
    else {
      this.router.navigate(['/tour/selftour/schedule-selftour']);
    }

    this.prospectService.GetProspectSelfTourSummary(this.selfTourKey).subscribe(res => this.onGetProspectSelfTourSummary(res), err => this.errorService.showError(err));
   }

  ngOnInit() {
  }

  onGetProspectSelfTourSummary(tour: ProspectTourSummary)
  {
    this.model = tour;
    this.createCalendarWidget();
  }

  createCalendarWidget(){

    var myCalendar = createCalendar({
      data: {
        title: `Self Tour at ${this.model.Address}`,
        start: new Date(this.model.EventStart),
        end: new Date(this.model.EventEnd),     
        address: this.model.Address,
        description: ''
      }
    });
    
    myCalendar.querySelector('label.add-to-calendar-checkbox').innerHTML = "<div class='flex justify-start items-center hover:text-true-blue'><span class='material-icons '>calendar_today</span>&nbsp;<span class='text-base hover:font-bold font-body' id='oh-summary-atc-text'>ADD TO CALENDAR</span><div>";

    document.querySelector('#selftour-cal-anchor').appendChild(myCalendar);
  }

  finish(){
    this.router.navigate(['/account/tours']);
  }

}
